import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart, FaEye, FaHeart, FaFish, FaMars, FaVenus, FaExchangeAlt, FaStar } from "react-icons/fa";

const GuppyCard = ({ guppy = {}, onOrderClick }) => {
  const [showFemale, setShowFemale] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const {
    name = "Unnamed Guppy",
    coupleprice = 0,
    maleprice = 0,
    femaleprice = 0,
    sold_status = false,
    maleimage = null,
    femaleimage = null,
    couplecount = 0,
    malecount = 0,
    femalecount = 0,
    singular = false,
    guppynumber,
  } = guppy;

  const navigate = useNavigate();

  const formattedcouplePrice =
    typeof coupleprice === "number" ? coupleprice.toFixed(2) : "N/A";
  const formattedMalePrice =
    typeof maleprice === "number" ? maleprice.toFixed(2) : "N/A";
  const formattedFemalePrice =
    typeof femaleprice === "number" ? femaleprice.toFixed(2) : "N/A";

  const bothImagesExist = maleimage && femaleimage;
  const onlyFemaleExists = !maleimage && femaleimage;
  const onlyMaleExists = maleimage && !femaleimage;

  const imageToShow =
    onlyFemaleExists || (showFemale && femaleimage) ? femaleimage : maleimage;

  const canOrderCouple = couplecount > 0;
  const canOrderSingle =
    (maleimage && malecount > 0) || (femaleimage && femalecount > 0);

  const currentPrice = canOrderCouple || bothImagesExist
    ? formattedcouplePrice
    : onlyFemaleExists
    ? formattedFemalePrice
    : onlyMaleExists
    ? formattedMalePrice
    : showFemale
    ? formattedFemalePrice
    : formattedMalePrice;

  const handleOrderClick = () => {
    if (onOrderClick) {
      const orderItem = {
        ...guppy,
        guppynumber:  guppy.id || `guppy_${Date.now()}`,
      };
      onOrderClick(orderItem);
    }
  };

  useEffect(() => {
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    setIsLiked(favorites.includes(guppy.id));
  }, [guppy.id]);

  const toggleFavorite = () => {
    const newLikedState = !isLiked;
    setIsLiked(newLikedState);
    
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    if (newLikedState) {
      if (!favorites.includes(guppy.id)) {
        localStorage.setItem('favorites', JSON.stringify([...favorites, guppy.id]));
      }
    } else {
      localStorage.setItem('favorites', JSON.stringify(favorites.filter(id => id !== guppy.id)));
    }
  };

  return (
    <>
      <style>{`
        @keyframes imageReveal {
          from { transform: scale(1.1); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes heartBeat {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        @keyframes shimmer {
          0% { background-position: -200px 0; }
          100% { background-position: calc(200px + 100%) 0; }
        }
        @keyframes ripple {
          0% { transform: scale(0); opacity: 1; }
          100% { transform: scale(4); opacity: 0; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes priceGlow {
          0%, 100% { text-shadow: 0 0 5px rgba(16, 185, 129, 0.5); }
          50% { text-shadow: 0 0 20px rgba(16, 185, 129, 0.8), 0 0 30px rgba(16, 185, 129, 0.6); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .guppy-card {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .guppy-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 25px 50px -12px rgba(16, 185, 129, 0.4), 0 0 0 1px rgba(16, 185, 129, 0.3) !important;
        }
        
        .image-container {
          position: relative;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        
        .guppy-image {
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          object-fit: contain;
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 100%;
        }
        .guppy-card:hover .guppy-image {
          transform: scale(1.05);
        }
        
        .heart-button {
          transition: all 0.2s ease;
          backdrop-filter: blur(10px);
        }
        .heart-button:hover {
          transform: scale(1.1);
          background: rgba(0, 0, 0, 0.8) !important;
        }
        .heart-button.liked {
          animation: heartBeat 0.6s ease-in-out;
          color: #ef4444 !important;
          background: rgba(239, 68, 68, 0.2) !important;
        }
        
        .primary-button {
          background: linear-gradient(135deg, #10b981, #06b6d4) !important;
          border: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }
        .primary-button:hover {
          background: linear-gradient(135deg, #059669, #0891b2) !important;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4) !important;
        }
        .primary-button:active {
          transform: translateY(0);
        }
        .primary-button::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: width 0.3s, height 0.3s;
        }
        .primary-button:active::after {
          width: 300px;
          height: 300px;
        }
        
        .secondary-button {
          background: rgba(6, 182, 212, 0.15) !important;
          border: 1px solid rgba(6, 182, 212, 0.4) !important;
          color: #06b6d4 !important;
          transition: all 0.3s ease;
        }
        .secondary-button:hover {
          background: rgba(6, 182, 212, 0.25) !important;
          border-color: rgba(6, 182, 212, 0.6) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(6, 182, 212, 0.2);
        }
        
        .sold-out-button {
          background: rgba(239, 68, 68, 0.1) !important;
          border: 1px solid rgba(239, 68, 68, 0.3) !important;
          color: #ef4444 !important;
          cursor: not-allowed !important;
          opacity: 0.7;
        }
        
        .gender-switcher {
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }
        .gender-switcher:hover {
          transform: scale(1.05);
          background: rgba(16, 185, 129, 0.9) !important;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
        
        .loading-skeleton {
          background: linear-gradient(90deg, rgba(51, 65, 85, 0.3) 25%, rgba(71, 85, 105, 0.5) 50%, rgba(51, 65, 85, 0.3) 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }
        
        /* Removed infinite animations for performance */
        .info-row {
          transition: all 0.2s ease;
          border-radius: 6px;
          margin: 2px 0;
        }
        .info-row:hover {
          background: rgba(16, 185, 129, 0.08);
          transform: translateX(-3px);
        }
        
        /* Responsive Design */
        @media (max-width: 640px) {
          .guppy-card {
            min-height: 520px !important;
          }
          .card-button {
            font-size: 13px !important;
            padding: 10px 12px !important;
          }
          .info-container {
            padding: 10px !important;
          }
        }
        
        @media (max-width: 480px) {
          .guppy-card {
            min-height: 500px !important;
          }
          .image-container {
            height: 220px !important;
          }
          .card-button {
            font-size: 12px !important;
            padding: 8px 10px !important;
            min-height: 40px !important;
          }
        }
      `}</style>

      <div
        className="guppy-card"
        style={{
          background: "linear-gradient(135deg, rgba(15, 23, 42, 0.80), rgba(30, 41, 59, 0.68))",
          backdropFilter: "blur(2px)",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(71, 85, 105, 0.2)",
          width: "100%",
          height: "100%",
          minHeight: "560px",
          border: "1px solid rgba(16, 185, 129, 0.2)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Status Badge */}
        {sold_status && (
          <div className="floating-badge" style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            background: "linear-gradient(135deg, #ef4444, #dc2626)",
            color: "white",
            padding: "8px 14px",
            borderRadius: "25px",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: 10,
            boxShadow: "0 6px 20px rgba(239, 68, 68, 0.4)",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}>
            <FaStar size={12} />
            نفذت الكمية
          </div>
        )}

        {/* Like Button */}
        <button
          className={`heart-button ${isLiked ? 'liked' : ''}`}
          onClick={toggleFavorite}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "rgba(0, 0, 0, 0.6)",
            border: "none",
            borderRadius: "50%",
            width: "44px",
            height: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: isLiked ? "#ef4444" : "white",
            cursor: "pointer",
            zIndex: 10,
          }}
        >
          <FaHeart size={18} />
        </button>

        {/* Image Container - Modified to better handle images */}
        <div
          className="image-container"
          style={{
            width: "100%",
            height: "280px",
            background: "linear-gradient(135deg, rgba(15, 23, 42, 0.25), rgba(30, 41, 59, 0.15))",
            position: "relative",
            flexShrink: 0,
          }}
        >
          {imageToShow ? (
            !imageLoaded ? (
              <div className="loading-skeleton" style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#64748b",
                fontSize: "48px",
              }}>
                🐠
              </div>
            ) : null
          ) : (
            <div style={{
              color: "#64748b",
              fontSize: "64px",
              opacity: 0.5,
            }}>
              <FaFish />
            </div>
          )}
          
          {imageToShow && (
            <img
              className="guppy-image"
              src={imageToShow}
              alt={name}
              loading="lazy"
              style={{ 
                width: "auto",
                height: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                opacity: imageLoaded ? 1 : 0,
                position: imageLoaded ? "static" : "absolute",
                transition: "opacity 0.3s ease-in-out",
              }}
              onLoad={() => setImageLoaded(true)}
            />
          )}

          {/* Gender Switcher */}
          {bothImagesExist && (
            <button
              className="gender-switcher"
              onClick={() => setShowFemale(!showFemale)}
              style={{
                position: "absolute",
                bottom: "12px",
                right: "12px",
                background: "rgba(16, 185, 129, 0.8)",
                color: "white",
                border: "none",
                padding: "10px 14px",
                borderRadius: "25px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {showFemale ? <FaVenus size={12} /> : <FaMars size={12} />}
              {showFemale ? "أنثى" : "ذكر"}
              <FaExchangeAlt size={10} />
            </button>
          )}

          {/* Single Gender Label */}
          {!bothImagesExist && (onlyMaleExists || onlyFemaleExists) && (
            <div style={{
              position: "absolute",
              bottom: "12px",
              right: "12px",
              background: "rgba(0, 0, 0, 0.8)",
              color: "white",
              padding: "8px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              backdropFilter: "blur(8px)",
            }}>
              {onlyFemaleExists ? <FaVenus size={12} /> : <FaMars size={12} />}
              {onlyFemaleExists ? "أنثى" : "ذكر"}
            </div>
          )}
        </div>

        {/* Content */}
        <div className="info-container" style={{ 
          padding: "20px", 
          display: "flex", 
          flexDirection: "column", 
          flex: 1,
          gap: "16px"
        }}>
          {/* Title and Info */}
          <div style={{
            background: "linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(6, 182, 212, 0.08))",
            border: "1px solid rgba(16, 185, 129, 0.2)",
            borderRadius: "16px",
            padding: "16px",
            flex: 1,
          }}>
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(16, 185, 129, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#10b981", fontWeight: "bold", fontSize: "14px" }}>
                السلالة
              </span>
              <span style={{ 
                color: "white", 
                fontSize: "15px", 
                fontWeight: "600",
                textAlign: "right",
                wordBreak: "break-word",
                maxWidth: "60%"
              }}>
                {name}
              </span>
            </div>

            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(16, 185, 129, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#10b981", fontWeight: "bold", fontSize: "14px" }}>
                السعر
              </span>
              <span className="price-tag" style={{ 
                color: "#fbbf24", 
                fontSize: "18px", 
                fontWeight: "bold",
              }}>
                {currentPrice} DA
              </span>
            </div>

            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}>
              <span style={{ color: "#10b981", fontWeight: "bold", fontSize: "14px" }}>
                الحالة
              </span>
              <span className={sold_status ? "" : "status-available"} style={{
                color: sold_status ? "#ef4444" : "#10b981",
                fontSize: "14px",
                fontWeight: "600",
                padding: "6px 12px",
                borderRadius: "12px",
                background: sold_status 
                  ? "rgba(239, 68, 68, 0.15)" 
                  : "rgba(16, 185, 129, 0.15)",
              }}>
                {sold_status ? "نفذت الكمية" : "متاح"}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            gap: "12px",
            marginTop: "auto"
          }}>
            {/* Primary Action Button */}
            {canOrderCouple ? (
              <button 
                className="primary-button card-button"
                onClick={handleOrderClick}
                style={{
                  borderRadius: "16px",
                  padding: "14px 20px",
                  color: "white",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  boxShadow: "0 6px 20px rgba(16, 185, 129, 0.3)",
                  minHeight: "52px",
                }}
              >
                <FaShoppingCart size={16} />
                اطلب زوجا الآن
              </button>
            ) : canOrderSingle ? (
              <button 
                className="primary-button card-button"
                onClick={handleOrderClick}
                style={{
                  borderRadius: "16px",
                  padding: "14px 20px",
                  color: "white",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  boxShadow: "0 6px 20px rgba(16, 185, 129, 0.3)",
                  minHeight: "52px",
                }}
              >
                <FaShoppingCart size={16} />
                اطلب الآن
              </button>
            ) : (
              <div className="sold-out-button card-button" style={{
                borderRadius: "16px",
                padding: "14px 20px",
                fontSize: "15px",
                fontWeight: "bold",
                textAlign: "center",
                minHeight: "52px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}>
                <FaStar size={14} />
                {singular ? "تم البيع" : "لا يوجد أزواج متبقية"}
              </div>
            )}

            {/* Secondary Action Button */}
            {!singular && (
              <button
                className="secondary-button card-button"
                onClick={() => navigate("/guppy-details", { state: { guppy } })}
                style={{
                  borderRadius: "14px",
                  padding: "12px 18px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  minHeight: "46px",
                }}
              >
                <FaEye size={14} />
                عرض المزيد من التفاصيل
              </button>
            )}
          </div>
        </div>

        {/* Hover Glow Effect */}
        {isHovered && (
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(135deg, rgba(16, 185, 129, 0.05), rgba(6, 182, 212, 0.05))",
            borderRadius: "24px",
            pointerEvents: "none",
          }} />
        )}
      </div>
    </>
  );
};

export default React.memo(GuppyCard);